import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'tracker-query-edit-filters',
  template: require('./tracker.query.edit.filters.component.html'),
})
export class TrackerQueryEditFiltersComponent implements OnInit {
  @Input() tracker: any;
  @Input() textsearch: any;
  @Input() summary: any;
  @Input() submittedBy: any;
  @Input() currentFilters: any[];

  fieldSettingsMultiple = {
    showUncheckAll: true,
    showCheckAll: true
  };

  fieldSettingsSingle = {
    showUncheckAll: false,
    showCheckAll: false,
    selectionLimit: 1
  };

  ngOnInit() {
  }
}
